module.exports = __webpack_public_path__ + "img/transmutacao.495dab13.jpeg";